import * as React from "react";
import styled from "styled-components";
import { colorLayoutBorder } from "@rhumbix/rmbx_design_system_design_tokens";
const FormFieldGroup = ({ children }) => (React.createElement(StyledFormFieldGroup, null,
    React.createElement(FormFieldWrapper, null, children)));
// The margin extends 16px out to the right in order to allow the bottom border to extend
// outside the apparent bounds of the component. Then the contents are padded by the inner 
// wrapper to fit within the expected area. The horizontal rule could have been broken out as 
// its own div, but that would make it harder to use the :last-of-type selector that lets us
// skip the final bottom border
const StyledFormFieldGroup = styled.div `
    margin: 0 -16px 0 0;
    padding: 16px 0;
    height: auto;
    width: auto;
    border-bottom: 1px solid ${colorLayoutBorder};

    &:last-of-type {
        border-bottom: 0px
    }
`;
const FormFieldWrapper = styled.div `
    padding: 0 16px 0 0;
`;
export default FormFieldGroup;
